import Tasks from 'APP/Tasks';
import { terminateSessionsOld } from 'APP/Tasks/userSettings/terminateSessionsOld/terminateSessionsOld';
import { userSettingsModel } from 'APP/model/model';
import { DeviceStatus } from 'APP/model/userSettings/userSettingsModel.types';
import Entities from 'STORE';
import { SecretGroup } from 'STORE/Groups/SecretGroup/SecretGroup';

export async function terminateOrBlockSessions(
  deviceIds: string[],
  status: DeviceStatus.Blocked | DeviceStatus.Deleted
): Promise<boolean> {
  try {
    const secretGroupsIds = Entities.GroupsStore.groups
      .filter((group) => group instanceof SecretGroup && group.isUnlocked)
      .map((group) => group.id);

    await Promise.all(
      secretGroupsIds.map((groupId) => Tasks.e2ee.removeDevicesFromSecretGroup(groupId, deviceIds))
    );

    const response = await Promise.all(
      deviceIds.map((deviceId) =>
        userSettingsModel.setDeviceStatus({
          deviceId,
          status,
        })
      )
    );

    // backward capability with old backend
    if (response.some((item) => !item)) {
      await terminateSessionsOld(deviceIds);
    }

    return true;
  } catch (error) {
    return false;
  }
}
